import type { EntityType } from "@config";
import type { RepeatableField } from "./types";
import { scanSubtreeTokens } from "./scan-subtree-tokens";
import { inferFields, type KnownVariable } from "./infer-fields";

/**
 * Derive the field list a "make repeatable" mark would produce for the given
 * subtree, without mutating or patching anything. Shared by `planRepeatable`
 * (the actual mark step, in plan-repeatable.ts) and the "Add repeatable
 * group" dialog's predefined-data seeding UI, so both always agree on
 * exactly which tokens become fields.
 *
 * Every non-dotted token inside the subtree becomes a field — including one
 * the deck also uses elsewhere (a duplicated set, a cover slide), exactly as
 * inserting that variable into the group after marking namespaces it
 * (use-insert-variable.ts). Uses outside the subtree keep the plain variable.
 */
export const deriveRepeatableFields = (
  subtreeEntities: Record<string, EntityType>,
  knownVariables: KnownVariable[],
): RepeatableField[] => {
  const { inside } = scanSubtreeTokens(subtreeEntities, {});
  const fieldNames = inside
    .filter((n) => !n.includes(".")) // skip already-namespaced (nested) + global (hubspot./sender.) tokens
    .sort();
  return inferFields(fieldNames, knownVariables);
};
